import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTACards from './components/CTACards';
import ArticlePreview from './components/ArticlePreview';
import TestimonialSection from './components/TestimonialSection';
import FullCTA from './components/FullCTA';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gtbuyspreadsheet.work';

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'GTBuy Spreadsheet - Best Spreadsheet System for Buying Agents & E-commerce Sellers',
            description: 'Discover the GTBuy Spreadsheet system, the ultimate automation tool for buying agents, e-commerce sellers, and dropshippers.',
            url: siteUrl + '/',
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: 'Home',
                  item: siteUrl + '/',
                },
              ],
            },
            mainEntity: {
              '@type': 'Organization',
              name: 'GTBuySpreadsheet',
              url: siteUrl + '/',
            },
          }),
        }}
      />
      <HeroSection />
      <CategoryGrid />
      <CTACards />
      <ArticlePreview />
      <TestimonialSection />
      <FullCTA />
    </main>
  );
}